import styled from 'styled-components';
import { COLORS } from '../../../constants/colors';

export const Container = styled.div`
  .panda-input--small {
    margin-bottom: 0;
  }
`;

export const RecordItem = styled.button`
  align-items: center;
  border-bottom: 1px solid ${COLORS.grayBorder};
  display: flex;
  height: 40px;
  padding: 0 12px;
  width: 100%;
  transition: background-color ease-in 60ms;

  &:hover,
  &:focus {
    background-color: ${COLORS.blueHover};
    cursor: pointer;
  }
`;

export const RecordText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
